// PORTFOLIO 18개 프로젝트 데이터 — 문구·사진 경로를 여기서 바꾸면 카드와 상세 화면이 함께 바뀝니다.
// 원본: 디자인 시안 assets/js/data/portfolio-data.js (사진 경로만 /assets/... 로 바꿈)
// - 카드 순서 = 배열 순서. 카드 번호(01/18)는 자동으로 붙습니다.
// - id 는 주소 ?project=<id> 에 쓰이므로 바꾸지 마세요.
// - work 는 최대 3개만 보입니다. metrics 는 검증된 수치만 넣어 주세요(0~4개, 4개면 2×2).
// - 사진 type: photo(현장 사진) / capture(채널·콘텐츠 캡처) / material(홍보물·콘텐츠)
//              composite(편집 이미지 · 실제 자료 조합) / editorial(편집 비주얼 · 현장 사진 아님)
// - 사진 교체 시 src·full·thumb·w·h(원본 픽셀)·pos(초점 위치)·type·cap 을 함께 고쳐 주세요.
const PORTFOLIO = [
  {
    "id": 18,
    "cat": "EVENTS",
    "year": "2026",
    "sortYear": 2026,
    "title": "aT Pet Fair SE Asia 2026 한국관 운영",
    "subtitle": "36개 한국기업의 바이어 상담부터 현장 운영까지",
    "meta": "aT / 한국관 / 바이어매칭·수출상담·전시운영",
    "description": "aT 한국관의 현장 운영과 바이어 상담, 온라인 카탈로그·영상 홍보를 함께 수행한 프로젝트입니다.",
    "work": [
      "36개사 사전 분석 · 바이어 발굴·초청·매칭",
      "한국관 안내·상담 지원 · 통역 · 현장 홍보·이벤트",
      "자체 개발 전자상담일지 운영 · 상담 기록·실적 집계·후속관리"
    ],
    "metrics": [
      [
        "308건",
        "3일간 수출상담"
      ],
      [
        "USD 446만",
        "상담 규모"
      ],
      [
        "205명",
        "상담 바이어(13개국)"
      ],
      [
        "5건",
        "MOU·LOI 체결"
      ]
    ],
    "links": [
      [
        "2026 한국관 운영 콘텐츠",
        "https://enjoylivek.com/kpet"
      ]
    ],
    "tags": [
      "aT 한국관",
      "바이어 매칭·수출상담",
      "전자상담일지 개발·운영"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-18-hero.jpg",
      "full": "/assets/img/photos/pf-18-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-18-hero.jpg",
      "w": 1600,
      "h": 1200,
      "pos": "50% 55%",
      "type": "photo",
      "cap": "aT 한국관(KOREA PAVILION) 부스 전경 · BITEC Bangkok"
    },
    "cover": {
      "src": "/assets/img/photos/pf-18-hero.jpg",
      "pos": "50% 55%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-18-g1.jpg",
        "full": "/assets/img/photos/pf-18-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g1.jpg",
        "w": 480,
        "h": 600,
        "pos": "50% 0%",
        "type": "material",
        "cap": "한국관 공식 홍보 포스터"
      },
      {
        "src": "/assets/img/photos/pf-18-g2.jpg",
        "full": "/assets/img/photos/pf-18-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g2.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "한국관 참가기업 부스 통로"
      },
      {
        "src": "/assets/img/photos/pf-18-g3.jpg",
        "full": "/assets/img/photos/pf-18-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g3.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 40%",
        "type": "photo",
        "cap": "참가기업–현지 바이어 MOU 체결"
      },
      {
        "src": "/assets/img/photos/pf-18-g4.jpg",
        "full": "/assets/img/photos/pf-18-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g4.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "MOU 라운지 라이브 방송 진행"
      },
      {
        "src": "/assets/img/photos/pf-18-g5.jpg",
        "full": "/assets/img/photos/pf-18-g5.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g5.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "인포데스크 방문객 운영"
      },
      {
        "src": "/assets/img/photos/pf-18-g6.jpg",
        "full": "/assets/img/photos/pf-18-g6.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g6.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "PETSONA 반려동물 카드 현장 출력"
      },
      {
        "src": "/assets/img/photos/pf-18-g7.jpg",
        "full": "/assets/img/photos/pf-18-g7.jpg",
        "thumb": "/assets/img/photos/t/pf-18-g7.jpg",
        "w": 1477,
        "h": 1108,
        "pos": "50% 55%",
        "type": "photo",
        "cap": "한국관 운영팀"
      }
    ],
    "note": "사진: 2026.10 Pet Fair SE Asia 현장 촬영 원본 · 포스터: enjoylivek.com"
  },
  {
    "id": 1,
    "cat": "TRADE",
    "year": "2018–2020",
    "sortYear": 2020,
    "title": "CP ALL × GLUCA Brand Launch",
    "subtitle": "한국 뷰티 브랜드 GLUCA, 태국 편의점 유통채널 진입",
    "meta": "민간기업 / K-Beauty / 브랜드 런칭·현지유통",
    "description": "CP ALL 벤더 등록과 GLUCA 3년 독점 공급계약을 바탕으로 한국 뷰티 브랜드 GLUCA의 태국 시장 런칭을 추진했습니다. 7-Eleven 채널의 제품 납품·물류·판매 운영까지 연결한 오프라인 유통 프로젝트입니다.",
    "work": [
      "CP ALL 벤더 등록 및 GLUCA 3년 독점 공급계약",
      "GLUCA 태국 런칭 · 7-Eleven 채널 유통",
      "제품 납품·물류·현지 판매 운영"
    ],
    "metrics": [
      [
        "2018–2020",
        "운영 기간"
      ],
      [
        "3년",
        "독점 공급계약"
      ]
    ],
    "links": [],
    "tags": [
      "CP ALL 벤더",
      "7-Eleven 채널",
      "K-Beauty 런칭"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-01-cover.jpg",
      "full": "/assets/img/covers/pf-01-cover.jpg",
      "thumb": "/assets/img/covers/pf-01-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "GLUCA 제품 홍보컷과 CP ALL·GLUCA 공식 로고를 정리한 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-01-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-01-g1.jpg",
        "full": "/assets/img/photos/pf-01-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-01-g1.jpg",
        "w": 526,
        "h": 526,
        "pos": "50% 50%",
        "type": "material",
        "cap": "GLUCA 태국 현지 홍보물"
      },
      {
        "src": "/assets/img/photos/pf-01-g2.jpg",
        "full": "/assets/img/photos/pf-01-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-01-g2.jpg",
        "w": 526,
        "h": 526,
        "pos": "50% 50%",
        "type": "material",
        "cap": "GLUCA 제품 홍보물"
      },
      {
        "src": "/assets/img/photos/pf-01-g3.jpg",
        "full": "/assets/img/photos/pf-01-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-01-g3.jpg",
        "w": 1600,
        "h": 800,
        "pos": "50% 50%",
        "type": "material",
        "cap": "한국 제품 런칭 홍보 비주얼"
      }
    ],
    "note": "대표 이미지는 공식 로고와 실제 브랜드 홍보물을 조합한 편집 이미지입니다."
  },
  {
    "id": 2,
    "cat": "TRADE",
    "year": "2019–2021",
    "sortYear": 2021,
    "title": "Robinson Department Store Distribution",
    "subtitle": "한국 캐릭터 화장품을 태국 백화점 42개 점포에 납품",
    "meta": "민간기업 / K-Beauty / 백화점 유통·납품",
    "description": "한국 인기 캐릭터 ‘라바’ 콜라보 화장품으로 Robinson 백화점 벤더 등록을 진행하고, 3년간 독점 납품하며 42개 점포로 태국 백화점 유통을 확대했습니다.",
    "work": [
      "Robinson 백화점 벤더 등록·채널 진입",
      "라바 콜라보 화장품 3년 독점 납품",
      "42개 점포 공급·유통 및 판매 운영"
    ],
    "metrics": [
      [
        "42개",
        "납품 점포"
      ],
      [
        "3년",
        "독점 납품"
      ]
    ],
    "links": [],
    "tags": [
      "Robinson 백화점",
      "캐릭터 콜라보 화장품",
      "벤더 등록·납품"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-02-poster.jpg",
      "full": "/assets/img/covers/pf-02-poster.jpg",
      "thumb": "/assets/img/covers/pf-02-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "Robinson 공식 로고·프로젝트 정보와 라바 콜라보 화장품 사진을 정리한 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-02-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-02-g1.jpg",
        "full": "/assets/img/photos/pf-02-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-02-g1.jpg",
        "w": 512,
        "h": 288,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "라바 콜라보 화장품 진열 · 현지 전시 상담 현장"
      }
    ],
    "note": "대표 이미지는 포스터형 편집 이미지이며 매장 현장 사진이 아닙니다. 갤러리 사진: 회사소개서 수록 사진"
  },
  {
    "id": 3,
    "cat": "DIGITAL",
    "year": "2026",
    "sortYear": 2026,
    "title": "aT 태국·미얀마 K-Food 뉴미디어 마케팅",
    "subtitle": "태국·미얀마 대상 K-Food 디지털 마케팅 · 4개 채널 운영",
    "meta": "aT / 2026 · Thailand & Myanmar / SNS 4채널·O2O 연계",
    "description": "태국·미얀마 소비자를 대상으로 YouTube·Facebook·TikTok·LINE 4개 채널을 운영하며 현지화 K-Food 콘텐츠를 기획·제작했습니다. 소비자 참여형 SNS 캠페인과 온·오프라인 연계 홍보, 성과 관리를 함께 수행했습니다.",
    "work": [
      "4개 채널 운영 및 현지화 콘텐츠 기획·제작",
      "소비자 참여형 SNS 캠페인 운영",
      "온·오프라인 연계 홍보 및 성과 관리"
    ],
    "metrics": [
      [
        "4개",
        "운영 채널"
      ]
    ],
    "links": [
      [
        "Enjoy K Food · YouTube",
        "https://www.youtube.com/@enjoykfood3504"
      ],
      [
        "Enjoy K Food · Facebook",
        "https://www.facebook.com/enjoykfood/?locale=ko_KR"
      ]
    ],
    "tags": [
      "YouTube",
      "Facebook",
      "TikTok",
      "LINE"
    ],
    "related": "POSCO TCS Enjoy K-Food Day · Carlton Hotel K-Grape · 한국유학박람회 aT 체험존",
    "hero": {
      "src": "/assets/img/covers/pf-03-cover.jpg",
      "full": "/assets/img/covers/pf-03-cover.jpg",
      "thumb": "/assets/img/covers/pf-03-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "Enjoy K-Food 실제 운영 콘텐츠(TikTok 채널·게시물·숏폼·YouTube 영상)로 구성한 SNS 포트폴리오 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-03-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-03-g1.jpg",
        "full": "/assets/img/photos/pf-03-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g1.jpg",
        "w": 1110,
        "h": 1048,
        "pos": "50% 0%",
        "type": "capture",
        "cap": "YouTube 채널 화면 (2026.11 캡처)"
      },
      {
        "src": "/assets/img/photos/pf-03-g2.jpg",
        "full": "/assets/img/photos/pf-03-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g2.jpg",
        "w": 1600,
        "h": 1169,
        "pos": "50% 0%",
        "type": "capture",
        "cap": "TikTok 채널 화면"
      },
      {
        "src": "/assets/img/photos/pf-03-g3.jpg",
        "full": "/assets/img/photos/pf-03-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g3.jpg",
        "w": 1234,
        "h": 1600,
        "pos": "50% 0%",
        "type": "capture",
        "cap": "Facebook 페이지 화면"
      },
      {
        "src": "/assets/img/photos/pf-03-g4.jpg",
        "full": "/assets/img/photos/pf-03-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g4.jpg",
        "w": 746,
        "h": 527,
        "pos": "50% 50%",
        "type": "material",
        "cap": "현지화 캠페인 콘텐츠"
      },
      {
        "src": "/assets/img/photos/pf-03-g5.jpg",
        "full": "/assets/img/photos/pf-03-g5.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g5.jpg",
        "w": 512,
        "h": 640,
        "pos": "50% 20%",
        "type": "material",
        "cap": "소비자 참여형 캠페인(My Pick) 콘텐츠"
      },
      {
        "src": "/assets/img/photos/pf-03-g6.jpg",
        "full": "/assets/img/photos/pf-03-g6.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g6.jpg",
        "w": 1280,
        "h": 961,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "연계 사례 · 한국유학박람회 aT 체험존"
      },
      {
        "src": "/assets/img/photos/pf-03-g7.jpg",
        "full": "/assets/img/photos/pf-03-g7.jpg",
        "thumb": "/assets/img/photos/t/pf-03-g7.jpg",
        "w": 1280,
        "h": 961,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "체험존 룰렛·시식 이벤트"
      }
    ],
    "note": "YouTube 화면은 2026.11 공개 채널 캡처, TikTok·Facebook 화면은 회사소개서 수록 캡처입니다. LINE은 운영 채널로 표기합니다."
  },
  {
    "id": 4,
    "cat": "DIGITAL",
    "year": "2025",
    "sortYear": 2025,
    "title": "Korea–Thailand Influencer Live Commerce Pilot",
    "subtitle": "31명 인플루언서와 40시간 라이브커머스 운영",
    "meta": "2025.03–12 · 1·2차 캠페인 · 리뷰 → 라이브 → 판매·수출",
    "description": "2025년 3~12월, Dr.MISIMOU·DIMODIVE·모두바른 등 한국 브랜드의 태국 소비자 접점을 넓히기 위해 인플루언서 리뷰와 TikTok 라이브, 판매를 연결했습니다. 2차 캠페인에서 라이브를 20회·40시간으로 확대했고, 모두바른 페이셜폼 3,000개 수출·통관으로 이어졌습니다.",
    "work": [
      "한국 브랜드 리뷰·라이브 캠페인 기획 (1·2차)",
      "현지 인플루언서 리뷰·SNS 콘텐츠 제작 (TikTok·Facebook·Instagram)",
      "TikTok 라이브커머스 운영 및 판매·수출 연계"
    ],
    "metrics": [
      [
        "31명",
        "인플루언서"
      ],
      [
        "250만",
        "인플루언서 총 팔로워"
      ],
      [
        "40시간",
        "라이브 방송 (20회)"
      ],
      [
        "6.9%",
        "라이브 참여율"
      ]
    ],
    "links": [],
    "tags": [
      "TikTok 라이브",
      "리뷰 콘텐츠",
      "수출·통관 연계"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-04-cover.jpg",
      "full": "/assets/img/covers/pf-04-cover.jpg",
      "thumb": "/assets/img/covers/pf-04-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "모두바른 페이셜폼 제품컷과 제품을 든 인플루언서 리뷰·라이브 화면"
    },
    "cover": {
      "src": "/assets/img/covers/pf-04-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-04-g1.jpg",
        "full": "/assets/img/photos/pf-04-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g1.jpg",
        "w": 406,
        "h": 720,
        "pos": "50% 40%",
        "type": "material",
        "cap": "모두바른 페이셜폼 제품 콘텐츠"
      },
      {
        "src": "/assets/img/photos/pf-04-g2.jpg",
        "full": "/assets/img/photos/pf-04-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g2.jpg",
        "w": 490,
        "h": 751,
        "pos": "50% 30%",
        "type": "capture",
        "cap": "Dr.MISIMOU 리뷰 콘텐츠"
      },
      {
        "src": "/assets/img/photos/pf-04-g3.jpg",
        "full": "/assets/img/photos/pf-04-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g3.jpg",
        "w": 563,
        "h": 1160,
        "pos": "50% 30%",
        "type": "capture",
        "cap": "모두바른 페이셜폼 리뷰"
      },
      {
        "src": "/assets/img/photos/pf-04-g4.jpg",
        "full": "/assets/img/photos/pf-04-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g4.jpg",
        "w": 466,
        "h": 783,
        "pos": "50% 30%",
        "type": "capture",
        "cap": "DIMODIVE 라이브 판매"
      },
      {
        "src": "/assets/img/photos/pf-04-g5.jpg",
        "full": "/assets/img/photos/pf-04-g5.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g5.jpg",
        "w": 563,
        "h": 1152,
        "pos": "50% 30%",
        "type": "capture",
        "cap": "Dr.MISIMOU 라이브 방송"
      },
      {
        "src": "/assets/img/photos/pf-04-g6.jpg",
        "full": "/assets/img/photos/pf-04-g6.jpg",
        "thumb": "/assets/img/photos/t/pf-04-g6.jpg",
        "w": 563,
        "h": 1152,
        "pos": "50% 30%",
        "type": "capture",
        "cap": "모두바른 라이브 방송"
      }
    ],
    "note": "콘텐츠 화면: BMK Live 포트폴리오(회사 자료) 수록 캡처"
  },
  {
    "id": 5,
    "cat": "EVENTS",
    "year": "2026",
    "sortYear": 2026,
    "title": "대구국제뷰티엑스포 태국관 운영",
    "subtitle": "현장 홍보·제품 시연·라이브커머스·태국 마케팅을 연결한 태국관 운영",
    "meta": "2026 · EXCO Daegu / Thailand Pavilion · Live Commerce",
    "description": "대구국제뷰티엑스포 태국관(B14 INBA · B15 Live-K)을 기획·운영하고, 국내 뷰티기업의 태국 시장 진출과 현지 홍보를 지원했습니다.",
    "work": [
      "태국관 기획·현장 운영 및 참가기업 제품 홍보",
      "태국 인플루언서 라이브커머스 기획·진행",
      "홍보 콘텐츠 촬영·SNS 확산 및 후속 마케팅 지원"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "태국관 운영",
      "인플루언서 라이브",
      "제품 홍보·상담"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-05-hero.jpg",
      "full": "/assets/img/photos/pf-05-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-05-hero.jpg",
      "w": 1600,
      "h": 1200,
      "pos": "50% 55%",
      "type": "photo",
      "cap": "태국관 B14 INBA · B15 Live-K 부스 전경 · EXCO Daegu"
    },
    "cover": {
      "src": "/assets/img/photos/pf-05-hero.jpg",
      "pos": "50% 55%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-05-g1.jpg",
        "full": "/assets/img/photos/pf-05-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-05-g1.jpg",
        "w": 1200,
        "h": 1600,
        "pos": "50% 40%",
        "type": "photo",
        "cap": "태국 인플루언서 라이브커머스 진행"
      },
      {
        "src": "/assets/img/photos/pf-05-g2.jpg",
        "full": "/assets/img/photos/pf-05-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-05-g2.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 55%",
        "type": "photo",
        "cap": "태국 시장 진출 상담"
      },
      {
        "src": "/assets/img/photos/pf-05-g3.jpg",
        "full": "/assets/img/photos/pf-05-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-05-g3.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "부스 현장 영상 인터뷰 촬영"
      },
      {
        "src": "/assets/img/photos/pf-05-g4.jpg",
        "full": "/assets/img/photos/pf-05-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-05-g4.jpg",
        "w": 1600,
        "h": 1200,
        "pos": "50% 55%",
        "type": "photo",
        "cap": "참가기업 제품 전시"
      },
      {
        "src": "/assets/img/photos/pf-05-g5.jpg",
        "full": "/assets/img/photos/pf-05-g5.jpg",
        "thumb": "/assets/img/photos/t/pf-05-g5.jpg",
        "w": 1200,
        "h": 1600,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "태국관 운영팀"
      }
    ],
    "note": "사진: 2026.06 EXCO 현장 촬영 원본"
  },
  {
    "id": 6,
    "cat": "EVENTS",
    "year": "2025",
    "sortYear": 2025,
    "title": "Paradise Park Hongcheon Special Event",
    "subtitle": "한국 특산품 6개사 제품의 전시·판매와 고객 참여·온라인 콘텐츠 연계",
    "meta": "2025.12 · Paradise Park Bangkok / 10-day Special Promotion",
    "description": "태국 Paradise Park에서 강원도 홍천 특산품 판매전을 10일간 기획·운영했습니다. 6개 기업 제품의 전시·판매와 시식·체험 프로그램, 라이브커머스를 함께 진행해 현장 판매 768개를 기록했습니다.",
    "work": [
      "판매전 기획 및 현장 운영 총괄",
      "홍천 6개 기업 제품 전시·현장 판매 지원",
      "시식·체험 참여 프로그램과 라이브커머스·SNS 홍보"
    ],
    "metrics": [
      [
        "10일",
        "판매전 운영"
      ],
      [
        "6개사",
        "참가 한국 기업"
      ],
      [
        "768개",
        "현장 판매"
      ]
    ],
    "links": [],
    "tags": [
      "한국 특산품 판매전",
      "현장 체험·시식",
      "라이브 연계"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-06-hero.jpg",
      "full": "/assets/img/photos/pf-06-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-06-hero.jpg",
      "w": 1600,
      "h": 1599,
      "pos": "50% 40%",
      "type": "photo",
      "cap": "홍천 특산품 판매전 현장 운영"
    },
    "cover": {
      "src": "/assets/img/photos/pf-06-hero.jpg",
      "pos": "50% 40%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-06-g1.jpg",
        "full": "/assets/img/photos/pf-06-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-06-g1.jpg",
        "w": 1600,
        "h": 1600,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "현장 운영팀"
      },
      {
        "src": "/assets/img/photos/pf-06-g2.jpg",
        "full": "/assets/img/photos/pf-06-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-06-g2.jpg",
        "w": 1048,
        "h": 1397,
        "pos": "50% 40%",
        "type": "photo",
        "cap": "참가기업 제품 홍보"
      },
      {
        "src": "/assets/img/photos/pf-06-g3.jpg",
        "full": "/assets/img/photos/pf-06-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-06-g3.jpg",
        "w": 762,
        "h": 1016,
        "pos": "50% 40%",
        "type": "photo",
        "cap": "판매전 홍보 부스"
      },
      {
        "src": "/assets/img/photos/pf-06-g4.jpg",
        "full": "/assets/img/photos/pf-06-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-06-g4.jpg",
        "w": 1600,
        "h": 640,
        "pos": "50% 50%",
        "type": "material",
        "cap": "홍천 특산품 프로모션 공식 배너"
      }
    ],
    "note": "사진: 회사 제공 현장 사진 원본 · 판매 수량: 2025 해외마케팅 실적보고서(참여기업별 판매표) 기준"
  },
  {
    "id": 7,
    "cat": "EVENTS",
    "year": "2023",
    "sortYear": 2023,
    "title": "Seacon Square KOREA DAY",
    "subtitle": "한국 브랜드와 태국 소비자를 연결한 KOREA DAY 팝업",
    "meta": "Seacon Square 백화점 1층 팝업 · 11일 운영",
    "description": "태국 Seacon Square 백화점에서 KOREA DAY 팝업 행사 기획·운영을 수행했습니다. 한국 기업 4개사 및 태국 기업이 참여한 상품 전시·홍보·현장 판매 프로그램입니다.",
    "work": [
      "Seacon Square KOREA DAY 팝업 기획·운영",
      "한국 기업 4개사와 태국 기업 참여 지원",
      "현장 제품 전시·판매·프로모션"
    ],
    "metrics": [
      [
        "11일",
        "팝업 운영"
      ],
      [
        "4개사",
        "참가 한국기업"
      ]
    ],
    "links": [],
    "tags": [
      "KOREA DAY 팝업",
      "한국 브랜드 전시·판매",
      "백화점 1층"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-07-cover.jpg",
      "full": "/assets/img/covers/pf-07-cover.jpg",
      "thumb": "/assets/img/covers/pf-07-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "Seacon Square KOREA DAY 현장 사진을 정리한 이미지"
    },
    "cover": {
      "src": "/assets/img/photos/pf-07-g1.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-07-g1.jpg",
        "full": "/assets/img/photos/pf-07-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-07-g1.jpg",
        "w": 807,
        "h": 605,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "참가 브랜드 부스"
      },
      {
        "src": "/assets/img/photos/pf-07-g2.jpg",
        "full": "/assets/img/photos/pf-07-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-07-g2.jpg",
        "w": 807,
        "h": 605,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "Seacon Square 행사장"
      },
      {
        "src": "/assets/img/photos/pf-07-g3.jpg",
        "full": "/assets/img/photos/pf-07-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-07-g3.jpg",
        "w": 444,
        "h": 333,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "KOREA DAY 한국 제품 판매"
      },
      {
        "src": "/assets/img/photos/pf-07-g4.jpg",
        "full": "/assets/img/photos/pf-07-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-07-g4.jpg",
        "w": 444,
        "h": 333,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "한국 테마 포토존"
      },
      {
        "src": "/assets/img/photos/pf-07-g5.jpg",
        "full": "/assets/img/photos/pf-07-g5.jpg",
        "thumb": "/assets/img/photos/t/pf-07-g5.jpg",
        "w": 444,
        "h": 333,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "행사장 전경"
      }
    ],
    "note": "사진: 회사소개서 수록 현장 사진"
  },
  {
    "id": 8,
    "cat": "EVENTS",
    "year": "2018–2023",
    "sortYear": 2023,
    "title": "K-Beauty Bangkok Exhibition & Buyer Matching",
    "subtitle": "한국 뷰티기업의 전시·바이어 상담·현지 협력 지원",
    "meta": "기관협력 / K-Beauty / 전시·바이어매칭",
    "description": "K-Beauty Bangkok 전시와 KINTEX 현지 파트너십을 통해 국내 기업의 태국 시장 진출을 지원한 연속 활동입니다. 전시 지원과 바이어 연결, 통역·비즈니스 미팅을 중심으로 수행했습니다.",
    "work": [
      "한국 기업의 태국 전시 참가·현장 지원",
      "바이어 매칭·통역·상담 일정 연결",
      "KINTEX 태국 현지 협력·마케팅 지원"
    ],
    "metrics": [
      [
        "2018–2023",
        "관련 수행 기간"
      ]
    ],
    "links": [],
    "tags": [
      "전시 참가 지원",
      "바이어 매칭·통역",
      "KINTEX 현지 협력"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-08-cover.jpg",
      "full": "/assets/img/covers/pf-08-cover.jpg",
      "thumb": "/assets/img/covers/pf-08-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "방콕 뷰티 전시·바이어 상담 현장 사진을 정리한 이미지"
    },
    "cover": {
      "src": "/assets/img/photos/pf-08-g2.jpg",
      "pos": "50% 42%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-08-g1.jpg",
        "full": "/assets/img/photos/pf-08-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-08-g1.jpg",
        "w": 653,
        "h": 490,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "참가기업 바이어 상담"
      },
      {
        "src": "/assets/img/photos/pf-08-g2.jpg",
        "full": "/assets/img/photos/pf-08-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-08-g2.jpg",
        "w": 653,
        "h": 490,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "참가기업 제품 상담"
      },
      {
        "src": "/assets/img/photos/pf-08-g3.jpg",
        "full": "/assets/img/photos/pf-08-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-08-g3.jpg",
        "w": 653,
        "h": 490,
        "pos": "50% 45%",
        "type": "photo",
        "cap": "현장 비즈니스 미팅"
      },
      {
        "src": "/assets/img/photos/pf-08-g4.jpg",
        "full": "/assets/img/photos/pf-08-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-08-g4.jpg",
        "w": 645,
        "h": 610,
        "pos": "50% 30%",
        "type": "material",
        "cap": "방콕 뷰티 전시 현장 모음"
      }
    ],
    "note": "사진: 회사소개서·enjoylivek.com 수록 현장 사진"
  },
  {
    "id": 9,
    "cat": "EVENTS",
    "year": "2019",
    "sortYear": 2019,
    "title": "Fantastic Night Market",
    "subtitle": "40여 개 한국 브랜드·100여 개 품목을 태국 현장에 소개",
    "meta": "2019.11 · Korat, Thailand / 오프라인 행사 / 나이트마켓·판촉",
    "description": "2019년 11월 한 달간 태국 코랏(Korat)에서 태국 최초의 한국 제품 나이트마켓을 진행했습니다. 화장품·의류·건강식품·주류 등 40여 개 한국 브랜드, 100여 개 품목을 현지 소비자에게 소개하고 체험·판촉·판매로 연결했습니다.",
    "work": [
      "태국 최초 한국 제품 나이트마켓 기획·운영",
      "화장품·의류·건강식품·주류 등 브랜드 전시",
      "현지 소비자 대상 체험·판촉·판매 운영"
    ],
    "metrics": [
      [
        "약 40개",
        "한국 브랜드"
      ],
      [
        "약 100개",
        "참가 품목"
      ],
      [
        "30일",
        "운영 기간"
      ]
    ],
    "links": [],
    "tags": [
      "한국 제품 나이트마켓",
      "체험·판촉·판매",
      "태국 최초"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-09-cover.jpg",
      "full": "/assets/img/covers/pf-09-cover.jpg",
      "thumb": "/assets/img/covers/pf-09-cover.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "composite",
      "cap": "Fantastic Night Market 2019 공식 키비주얼과 현장 사진을 정리한 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-09-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-09-g1.jpg",
        "full": "/assets/img/photos/pf-09-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-09-g1.jpg",
        "w": 804,
        "h": 794,
        "pos": "50% 50%",
        "type": "material",
        "cap": "Fantastic Night Market 2019 공식 키비주얼"
      },
      {
        "src": "/assets/img/photos/pf-09-g2.jpg",
        "full": "/assets/img/photos/pf-09-g2.jpg",
        "thumb": "/assets/img/photos/t/pf-09-g2.jpg",
        "w": 1600,
        "h": 688,
        "pos": "50% 50%",
        "type": "material",
        "cap": "NIGHT MARKET 2019 IN KORAT 행사 배너"
      },
      {
        "src": "/assets/img/photos/pf-09-g3.jpg",
        "full": "/assets/img/photos/pf-09-g3.jpg",
        "thumb": "/assets/img/photos/t/pf-09-g3.jpg",
        "w": 558,
        "h": 710,
        "pos": "50% 30%",
        "type": "photo",
        "cap": "공연·행사 현장 모음"
      },
      {
        "src": "/assets/img/photos/pf-09-g4.jpg",
        "full": "/assets/img/photos/pf-09-g4.jpg",
        "thumb": "/assets/img/photos/t/pf-09-g4.jpg",
        "w": 485,
        "h": 475,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "나이트마켓 현장"
      }
    ],
    "note": "자료: 회사소개서·enjoylivek.com 수록 행사 이미지"
  },
  {
    "id": 10,
    "cat": "EVENTS",
    "year": "2021",
    "sortYear": 2021,
    "title": "K-Beauty & Food Online Business Matching",
    "subtitle": "한국 뷰티·식품기업과 태국 바이어를 잇는 온라인 상담",
    "meta": "기관 주최 / K-Beauty·K-Food / 온라인 수출상담",
    "description": "KINTEX 주최 K-Beauty & Food 온라인 수출상담회 관련 사업입니다. 원격 환경에서 한국 기업과 태국 시장의 비즈니스 상담·교류를 연결했습니다.",
    "work": [
      "K-Beauty·K-Food 기업의 온라인 상담 지원",
      "한국 기업–태국 시장 비즈니스 미팅",
      "상담 진행 및 현지 협력 지원"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "온라인 수출상담",
      "K-Beauty·K-Food",
      "KINTEX 주최"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-10-poster.jpg",
      "full": "/assets/img/covers/pf-10-poster.jpg",
      "thumb": "/assets/img/covers/pf-10-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "프로젝트 정보를 정리한 포스터형 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-10-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [],
    "note": "대표 이미지는 프로젝트 정보를 정리한 포스터형 편집 이미지이며 현장 사진이 아닙니다."
  },
  {
    "id": 11,
    "cat": "EVENTS",
    "year": "2023",
    "sortYear": 2023,
    "title": "Thailand Biohealth Market Seminar",
    "subtitle": "태국 바이오헬스 시장 진출을 위한 산업 정보 교류",
    "meta": "시장 설명회 / 바이오헬스 / 태국 시장 진출",
    "description": "방콕 Grand Centre Point Hotel에서 개최된 KOINDO 주최 바이오헬스 시장 설명회 관련 활동입니다. 태국 현지 산업 환경과 비즈니스 진출 기회를 공유한 전문 행사입니다.",
    "work": [
      "바이오헬스 시장·산업환경 정보 공유",
      "태국 진출 관련 비즈니스 교류",
      "산업 관계자 간 네트워크 행사"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "시장 설명회",
      "바이오헬스",
      "방콕 개최"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-11-poster.jpg",
      "full": "/assets/img/covers/pf-11-poster.jpg",
      "thumb": "/assets/img/covers/pf-11-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "프로젝트 정보를 정리한 포스터형 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-11-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [],
    "note": "대표 이미지는 프로젝트 정보를 정리한 포스터형 편집 이미지이며 현장 사진이 아닙니다."
  },
  {
    "id": 12,
    "cat": "EVENTS",
    "year": "2025",
    "sortYear": 2025,
    "title": "International Vegan Fair — Thailand Market Seminar",
    "subtitle": "국내 비건기업 대상 태국 시장 진출 전략 공유",
    "meta": "시장 설명회 / 비건 산업 / 태국 진출 전략",
    "description": "서울 COEX 국제비건페어와 연계한 태국 진출 전략 설명회입니다. 비건 산업의 해외 시장 기회와 현지 사업 환경에 대한 정보를 소개했습니다.",
    "work": [
      "태국 비건 시장 환경·진출 전략 안내",
      "한국 비건 브랜드의 해외 진출 정보 공유",
      "전문 행사 연계 비즈니스 교류"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "시장 설명회",
      "비건 산업",
      "COEX 연계"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-12-poster.jpg",
      "full": "/assets/img/covers/pf-12-poster.jpg",
      "thumb": "/assets/img/covers/pf-12-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "프로젝트 정보를 정리한 포스터형 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-12-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [],
    "note": "대표 이미지는 프로젝트 정보를 정리한 포스터형 편집 이미지이며 현장 사진이 아닙니다."
  },
  {
    "id": 13,
    "cat": "EVENTS",
    "year": "2019",
    "sortYear": 2019,
    "title": "K-Beauty Bangkok Exhibitor Briefing",
    "subtitle": "K-Beauty Bangkok 참가기업의 현지 전시 준비 지원",
    "meta": "참가기업 지원 / K-Beauty / 전시 사전설명회",
    "description": "2019년 KINTEX에서 열린 K-Beauty Bangkok 참가기업 사전설명회 관련 활동입니다. 참가기업이 태국 현지 전시 및 시장 환경을 이해하도록 정보를 공유했습니다.",
    "work": [
      "전시 참가 준비·실무 안내",
      "태국 뷰티시장 정보 공유",
      "전시 참가기업 대상 사전설명회"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "참가기업 사전설명회",
      "K-Beauty",
      "KINTEX"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-13-poster.jpg",
      "full": "/assets/img/covers/pf-13-poster.jpg",
      "thumb": "/assets/img/covers/pf-13-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "프로젝트 정보를 정리한 포스터형 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-13-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [],
    "note": "대표 이미지는 프로젝트 정보를 정리한 포스터형 편집 이미지이며 현장 사진이 아닙니다."
  },
  {
    "id": 14,
    "cat": "EVENTS",
    "year": "2018",
    "sortYear": 2018,
    "title": "K-Beauty Expo — Thailand Market Strategy Seminar",
    "subtitle": "한국 뷰티기업 대상 태국 시장 진출 전략 소개",
    "meta": "시장 설명회 / K-Beauty / 해외 진출",
    "description": "2018년 KINTEX에서 진행된 K-Beauty Expo 태국 진출 전략 설명회입니다. 국내 뷰티기업을 대상으로 시장 환경과 비즈니스 기회를 소개했습니다.",
    "work": [
      "태국 뷰티시장 정보 공유",
      "한국 기업의 시장 진출 방향 안내",
      "KINTEX 설명회 프로그램 관련 활동"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "시장 설명회",
      "K-Beauty",
      "KINTEX"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-14-hero.jpg",
      "full": "/assets/img/photos/pf-14-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-14-hero.jpg",
      "w": 822,
      "h": 463,
      "pos": "50% 50%",
      "type": "photo",
      "cap": "2018 K-Beauty Expo 태국 시장 진출 설명회 · KINTEX"
    },
    "cover": {
      "src": "/assets/img/photos/pf-14-hero.jpg",
      "pos": "50% 50%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-14-g1.jpg",
        "full": "/assets/img/photos/pf-14-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-14-g1.jpg",
        "w": 548,
        "h": 309,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "설명회 발표 현장"
      }
    ],
    "note": "사진: 회사 제공 현장 사진"
  },
  {
    "id": 15,
    "cat": "EVENTS",
    "year": "2018",
    "sortYear": 2018,
    "title": "Cosmo Beauty Seoul — Thailand Market Seminar",
    "subtitle": "뷰티산업과 태국 시장을 연결한 전문 세미나",
    "meta": "시장 설명회 / K-Beauty / 태국 진출",
    "description": "서울 COEX의 Cosmo Beauty Seoul 행사와 연계해 태국 진출 전략을 소개한 설명회입니다. 한국 뷰티기업과 해외 시장의 사업 환경에 관한 정보를 공유했습니다.",
    "work": [
      "태국 시장 현황 및 진출 전략 소개",
      "한국 뷰티기업 대상 산업 정보 공유",
      "COEX 연계 전문 설명회"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "시장 설명회",
      "K-Beauty",
      "COEX"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-15-hero.jpg",
      "full": "/assets/img/photos/pf-15-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-15-hero.jpg",
      "w": 1600,
      "h": 1199,
      "pos": "50% 45%",
      "type": "photo",
      "cap": "Cosmo Beauty Seoul 2018 태국 시장 설명회"
    },
    "cover": {
      "src": "/assets/img/photos/pf-15-hero.jpg",
      "pos": "50% 45%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-15-g1.jpg",
        "full": "/assets/img/photos/pf-15-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-15-g1.jpg",
        "w": 591,
        "h": 444,
        "pos": "50% 50%",
        "type": "photo",
        "cap": "설명회 현장"
      }
    ],
    "note": "사진: 회사 제공 현장 사진 원본"
  },
  {
    "id": 16,
    "cat": "EVENTS",
    "year": "2018",
    "sortYear": 2018,
    "title": "International Management Consultant Training",
    "subtitle": "태국 현지 비즈니스 경험을 전문 교육으로 공유",
    "meta": "전문 교육 / 경영컨설팅 / 태국 분야 강의",
    "description": "한국경영기술지도사회 국제공인경영컨설턴트 양성과정에서 태국 분야 강의가 진행되었습니다. 태국 시장과 현지 사업 환경에 관한 전문지식을 다룬 교육 활동입니다.",
    "work": [
      "태국 시장·현지 사업환경 전문 강의",
      "해외사업 관련 컨설팅 지식 공유",
      "국제공인경영컨설턴트 양성과정 참여"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "전문 교육",
      "경영컨설팅",
      "태국 분야 강의"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/photos/pf-16-hero.jpg",
      "full": "/assets/img/photos/pf-16-hero.jpg",
      "thumb": "/assets/img/photos/t/pf-16-hero.jpg",
      "w": 1316,
      "h": 740,
      "pos": "50% 40%",
      "type": "photo",
      "cap": "국제공인경영컨설턴트(CMC KOREA) 과정 수여식"
    },
    "cover": {
      "src": "/assets/img/photos/pf-16-hero.jpg",
      "pos": "50% 40%"
    },
    "gallery": [
      {
        "src": "/assets/img/photos/pf-16-g1.jpg",
        "full": "/assets/img/photos/pf-16-g1.jpg",
        "thumb": "/assets/img/photos/t/pf-16-g1.jpg",
        "w": 1015,
        "h": 727,
        "pos": "50% 40%",
        "type": "photo",
        "cap": "과정 참가자 단체 사진"
      }
    ],
    "note": "사진: 회사소개서 ‘국제 공인경영컨설턴트(CMC KOREA)’ 슬라이드 수록 사진"
  },
  {
    "id": 17,
    "cat": "EVENTS",
    "year": "2017",
    "sortYear": 2017,
    "title": "InterCHARM Beauty Expo Korea — Thailand Market Seminar",
    "subtitle": "한국 화장품 기업 대상 태국 진출 전략 정보 교류",
    "meta": "시장 설명회 / K-Beauty / 태국 진출 전략",
    "description": "한국무역협회 주최 InterCHARM Beauty Expo Korea에서 태국 시장 진출 전략을 공유한 설명회 관련 활동입니다. 화장품 기업의 현지 시장 이해를 돕는 전문 교류 행사입니다.",
    "work": [
      "한국 화장품기업 대상 태국 시장 정보",
      "해외 진출 환경·전략 관련 전문 설명회",
      "전시 연계 비즈니스 교류"
    ],
    "metrics": [],
    "links": [],
    "tags": [
      "시장 설명회",
      "K-Beauty",
      "한국무역협회 주최"
    ],
    "related": "",
    "hero": {
      "src": "/assets/img/covers/pf-17-poster.jpg",
      "full": "/assets/img/covers/pf-17-poster.jpg",
      "thumb": "/assets/img/covers/pf-17-poster.jpg",
      "w": 1600,
      "h": 860,
      "pos": "50% 50%",
      "type": "editorial",
      "cap": "프로젝트 정보를 정리한 포스터형 편집 이미지"
    },
    "cover": {
      "src": "/assets/img/covers/pf-17-card.jpg",
      "pos": "50% 50%"
    },
    "gallery": [],
    "note": "대표 이미지는 프로젝트 정보를 정리한 포스터형 편집 이미지이며 현장 사진이 아닙니다."
  }
];

export default PORTFOLIO;
